module.exports = __webpack_public_path__ + "static/media/w-2_26.f51d4e76.png";